<h2 mat-dialog-title>New Medication Item</h2>
<mat-dialog-content>
  @if (form !== null) {
    <form class="form" [formGroup]="form" [class.form-validated]="validate">
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="fill" color="primary" class="w-100">
            <mat-label>Name</mat-label>
            <input matInput formControlName="description" type="text"/>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="fill" color="primary" class="w-100">
            <mat-label>Dosage</mat-label>
            <input matInput formControlName="dosage" type="text"/>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          @if (!hasType) {
            <xui-mat-autocomplete #typeAutocomplete class="w-100" placeholder="Search Medication Types" [searchObservable]="searchMedicationTypes$" (addNewItem)='addNewType()'
            [displayResultsCardTemplate]='displayTypeResultsCardTemplate' [addItemCardText]="'Add new medication type.'" ></xui-mat-autocomplete>
          }
          <ng-template #displayTypeResultsCardTemplate let-result="result" let-queryText="queryText">
            <div class="d-flex flex-row justify-content-between align-items-center cursor-pointer" (click)="typeSelected(result)">
              <span [innerHtml]="result.description | textHighlight: queryText"></span>
            </div>
          </ng-template>
          @if (hasType) {
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Medication Type</mat-label>
              <input matInput type="text" readonly value="{{medicationType?.description}}"/>
              <button matSuffix mat-icon-button (click)="clearType()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          }
        </div>
        <div class="col-12 col-md-6">
          @if (!hasDiagnosisCode) {
            <xui-mat-autocomplete #diagnosisAutocomplete class="w-100" placeholder="Search ICD10 Codes" [searchObservable]="searchDiagnosisCodes$"
            [displayResultsCardTemplate]='displayDiagnosisResultsCardTemplate'></xui-mat-autocomplete>
          }
          <ng-template #displayDiagnosisResultsCardTemplate let-result="result" let-queryText="queryText">
            <div class="d-flex flex-column cursor-pointer" (click)="diagnosisCodeSelected(result)">
              <span class="fw-bold" [innerHtml]="result.code | textHighlight: queryText"></span>
              <span class="text-muted small" [innerHtml]="result.description | textHighlight: queryText"></span>
            </div>
          </ng-template>
          @if (hasDiagnosisCode) {
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Diagnosis Code</mat-label>
              <input matInput type="text" readonly value="{{diagnosisCode?.code}} - {{diagnosisCode?.description}}"/>
              <button matSuffix mat-icon-button (click)="clearDiagnosisCode()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="text-muted small mb-0">Leave medication type blank to use the default type on save.</p>
        </div>
      </div>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="mx-3">
  <button type="button" mat-button (click)="close()">Close</button>
  <button type="button" mat-flat-button color="primary" (click)="save()">Save changes</button>
</mat-dialog-actions>
